"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.sendContactForm.name': 'Modulo di Contatto',
    'tools.sendContactForm.description': 'Raccoglie i dati del modulo di contatto (nome, email, telefono, messaggio) dai messaggi degli utenti e invia una richiesta di contatto',
};
